// extracted by mini-css-extract-plugin
export var container = "_dx-1";
export var cornerButtonContainer = "_dx-6";
export var disabled = "_dx-2";
export var dragActive = "_dx-3";
export var fileContainer = "_dx-5";
export var hiddenInput = "_dx-4";
export var widthContainer = "_dx-0";